import axios from 'axios'
import { AppSettings } from '../../configs'
import { authHeader } from '../../helpers/auth-header'

import {
    START_LOADING,
    STOP_LOADING,
    GET_REPORT_ON_SCREEN,
    GET_PDF_REPORT,
    GET_PDF_REPORT_COMMITTEE,
    GET_EXPORT_REPORT,
}
    from '../actions/actionTypes'

export function searchReportAction (serachCondition) {

    return function (dispatch) {

        dispatch({
            type: START_LOADING,
        })

        try {
            console.log('serachCondition :', serachCondition)
            let promise = axios({
                headers: authHeader(),
                method: 'post',
                url: `${ AppSettings.apiUrl }/api/ReportReceipt/GetReportReceiptVendor`,
                data: serachCondition,

            })

            promise.then(response => {
                    console.log(response.data)
                    dispatch({
                        type: GET_REPORT_ON_SCREEN,
                        payload: response.data,
                    })
                    dispatch({
                        type: STOP_LOADING,
                    })
                },
            ).finally(() => {
                dispatch({
                    type: STOP_LOADING,
                })
            })

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING,
            })

        } finally {
        }
    }
}

export function searchReportReceiptAction (searchCondition) {

    return function (dispatch) {

        dispatch({
            type: START_LOADING,
        })

        try {
            console.log('searchCondition Receipt :', searchCondition)
            let promise = axios({
                headers: authHeader(),
                method: 'post',
                url: `${ AppSettings.apiUrl }/api/ReportReceipt/GetReportReceipt`,
                data: searchCondition,

            })

            promise.then(response => {

                    dispatch({
                        type: GET_REPORT_ON_SCREEN,
                        payload: response.data,
                    })
                    dispatch({
                        type: STOP_LOADING,
                    })
                },
            ).finally(() => {
                dispatch({
                    type: STOP_LOADING,
                })
            })

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING,
            })

        } finally {
        }
    }
}

export function getReportReceiptPDF (transaction_no) {

    return function (dispatch) {
        dispatch({
            type: START_LOADING,
        })

        try {

            let promise = axios({
                headers: authHeader(),
                method: 'post',
                url: `${ AppSettings.apiUrl }/api/ReportReceipt/GetReceiptPdf`,
                data: transaction_no,

            })

            promise.then(response => {

                    dispatch({
                        type: GET_PDF_REPORT,
                        payload: response.data.length > 0 ? response.data[0] : response.data,
                    })
                    dispatch({
                        type: STOP_LOADING,
                    })
                },
            )

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING,
            })

        } finally {
        }
    }
}

export function getReportReceiptPDFCommittee (transaction_no) {

    return function (dispatch) {
        dispatch({
            type: START_LOADING,
        })

        try {

            let promise = axios({
                headers: authHeader(),
                method: 'post',
                url: `${ AppSettings.apiUrl }/api/ReportReceipt/GetReceiptPdfCommittee`,
                data: transaction_no,

            })

            promise.then(response => {

                    dispatch({
                        type: GET_PDF_REPORT_COMMITTEE,
                        payload: response.data,
                    })
                    dispatch({
                        type: STOP_LOADING,
                    })
                },
            )

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING,
            })

        } finally {
        }
    }
}

export function genReportReceiptPdf (transaction_no) {

    return function (dispatch) {
        dispatch({
            type: START_LOADING,
        })

        try {

            let promise = axios({
                headers: authHeader(),
                method: 'post',
                url: `${ AppSettings.apiUrl }/api/ReportReceipt/GenReceiptPdf`,
                data: transaction_no,

            })

            promise.then(response => {

                    dispatch({
                        type: GET_EXPORT_REPORT,
                        payload: response.data,
                    })
                    dispatch({
                        type: STOP_LOADING,
                    })
                },
            )

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING,
            })

        } finally {
        }
    }
}